<template>
	<div style="overflow-x: hidden">
		<div style="display: flex; flex-direction: column" v-if="idx === undefined">
			<!-- SIDEBAR -->
			<div class="menu" :style="{ width: sidebar ? '' : '75px' }">
				<button-collapse-sidebar :open="sidebar" @change="sidebar = !sidebar" />
				<folders-sidebar :open="sidebar" />
			</div>

			<div class="main" :style="{ width: widthscreen, marginLeft: !sidebar ? '75px' : '150px' }">
				<div style="padding: 10px; margin-top: 15px">
					<app-breadcrumb :history="breadcrumb" @mutate="doMutate" />
					<div class="header">
						<div class="header_title-container title">
							<h1>{{ $t("doc-archive") }}</h1>
							<h5>{{ computedDocNumber }}</h5>
						</div>
						<div class="header_actions">
							<div class="header_actions-container">
								<el-input
									style="width: auto"
									:placeholder="$t('documents-search')"
									v-model="docSearch"
									clearable
									@clear="handleSearch"
									@keyup.enter.native="handleSearch"
								>
									<el-button slot="append" icon="el-icon-search" @click="handleSearch" />
								</el-input>
							</div>
						</div>
					</div>

					<div class="documents infinite-list-wrapper" style="overflow: auto">
						<div
							class="documents_container list"
							v-infinite-scroll="scrollLoad"
							:infinite-scroll-disabled="scrollDisabled"
							infinite-scroll-distance="50"
							style="margin-bottom: 100px"
						>
							<div
								v-for="(d, indx) in docs"
								:key="d.id + d.actual"
								@mouseover="mousein(d.id)"
								@mouseleave="mouseout(d.id)"
								class="documents_wrapper list-item"
							>
								<div class="documents_upper">
									<div class="documents_thumb">
										<!-- <div :ref="'rnd_' + d.id">
											<Renderer
												v-if="d.preview != undefined"
												:key="uuid()"
												:valore="d.preview[0].items[0]"
												:dati="d.preview"
											></Renderer>
											<div :key="d.id" v-else>{{ $t("preview-not-available") }}</div>
										</div> -->
										<div :ref="'rnd_' + d.id" style="display: flex; height: 100%">
											<md-icon class="md-size-5x" style="color: #1a73e8">description</md-icon>
										</div>

										<div :ref="'opt_' + d.id" style="display: none">
											<div>
												<el-button
													type="primary"
													icon="el-icon-view"
													style="width: 100%; margin-top: 5px"
													plain
													@click="viewInfo(d.id)"
													>{{ $t("see-more") }}
												</el-button>
											</div>
											<div>
												<el-button
													type="success"
													icon="el-icon-refresh"
													style="width: 100%; margin-top: 5px"
													plain
													@click="recoverModal(d.id, true)"
												>
													{{ $t("restore-as-drafts") }}
												</el-button>
											</div>
											<div>
												<el-button
													type="success"
													icon="el-icon-refresh"
													style="width: 100%; margin-top: 5px"
													plain
													@click="recoverModal(d.id, false)"
												>
													{{ $t("restore-with-status") }}
												</el-button>
											</div>
										</div>
									</div>
								</div>
								<div class="documents_details">
									<div class="documents_details-menu">
										<span
											class="md-body-2"
											style="height: min-content; margin-top: auto; margin-bottom: auto"
										>
											{{ $t("version") }}
										</span>
										<el-select
											v-model="d.actual"
											:placeholder="$t('version')"
											@change="changeDocVersion(d.id, d.actual, indx)"
										>
											<el-option
												v-for="item in d.versions"
												:key="item.Id"
												:label="
													item.Version +
													' ' +
													(item.Status == 'published' ? '(' + $t('active') + ')' : '')
												"
												:value="item.Version"
											>
											</el-option>
										</el-select>
									</div>
									<div class="documents_details-infos">
										<div class="documents_details-title">{{ d.title }}</div>
										<div class="documents_details_second_row">
											<div>{{ $t("deleted") }} {{ d.time }}</div>
										</div>
										<div>
											<el-tag style="margin-left: 3px; margin-bottom: 3px" type="warning">
												{{ $t(d.status) }}
											</el-tag>
											<el-tag
												v-for="area in d.areas"
												:key="area.id"
												style="margin-left: 3px; margin-bottom: 3px"
												type="success"
											>
												{{ area.area.name }}
											</el-tag>
											<el-tag
												v-for="tag in d.tags"
												:key="tag.id"
												style="margin-left: 3px; margin-bottom: 3px"
											>
												{{ tag.tag.name }}
											</el-tag>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="float-center">
						<div class="float-content-spinner" v-if="scrollLoading">
							<i class="el-icon-loading" />
						</div>
						<div
							class="float-content"
							v-bind:class="{ visible: scrollNoMoreSnackbar, hidden: !scrollNoMoreSnackbar }"
						>
							<div class="float-text">{{ $t("no-more-docs") }}</div>
						</div>
					</div>

					<!--        render modal-->
					<el-dialog
						:key="showModalRender + uuid()"
						:title="$t('preview')"
						:visible.sync="showModalRender"
						width="80%"
					>
						<span slot="title"
							><i class="el-icon-document" style="margin-right: 10px"></i>{{ $t("preview") }}</span
						>
						<flat-renderer
							v-if="showModalRender"
							:dati="selected_nodes"
							id="rend"
							:key="showModalRender + uuid()"
							:toggleBorders="toggleBorders"
							:logged="true"
						/>
						<span slot="footer">
							<el-switch
								v-model="toggleBorders"
								:active-text="$t('with-borders')"
								:inactive-text="$t('without-borders')"
							/>
							<el-button style="margin-left: 20px" type="primary" @click="showModalRender = false">{{
								$t("close")
							}}</el-button>
						</span>
					</el-dialog>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import axios from "axios"
import moment from "moment"
import Renderer from "@/modules/builder/components/Renderer"
import FlatRenderer from "@/modules/flowcharts/flat-renderer"
import { goto } from "@/utils/utils"
import { uuid } from "@/modules/builder/utils/utils"
import { mapMutations } from "vuex"
import ButtonCollapseSidebar from "@/modules/_common/button/button-collapse-sidebar.vue"
import FoldersSidebar from "@/modules/documents/components/sidebar-components/folders-sidebar.vue"
import AppBreadcrumb from "@/modules/_common/app-breadcrumb.vue"

export default {
	name: "documents-layout",
	components: {
		Renderer,
		FlatRenderer,
		AppBreadcrumb,
		"button-collapse-sidebar": ButtonCollapseSidebar,
		"folders-sidebar": FoldersSidebar
	},
	data() {
		return {
			docSearch: "",
			docs: [],
			docsFilt: [],
			docNumber: "",

			showModalRender: false,
			selected_nodes: [],

			idx: undefined,
			toggleBorders: false,

			sidebar: true || window.innerWidth < 900,
			widthscreen: window.innerWidth - 150,
			heightscreen: window.innerHeight,
			mobile: window.innerWidth < 900,

			scrollLoading: false,
			scrollNoMoreSnackbar: false,
			scrollEnded: false,
			tilesNumber: 1,
			rowsToLoad: 4,
			loadedPages: 0
		}
	},
	watch: {
		idx() {
			this.docSearch = ""
			this.loadedPages = 0
			this.scrollEnded = false
			this.docs = []
			this.getDocs()
		},
		scrollNoMoreSnackbar() {
			if (this.scrollNoMoreSnackbar) {
				setTimeout(() => {
					this.scrollNoMoreSnackbar = false
				}, 3000)
			}
		}
	},
	computed: {
		...mapGetters({
			breadcrumb: "documents/breadcrumb"
		}),
		computedDocNumber: function () {
			return this.$t("documents-counter").replace("%DOCSNUMBER%", this.docNumber)
		},
		scrollDisabled() {
			return this.scrollLoading || this.scrollEnded
		}
	},
	created() {
		this.tilesNumber = Math.floor((this.widthscreen - 90) / 340)
		this.getDocs()
	},
	methods: {
		...mapMutations({
			openLoad: "modules/OPEN_LOADING",
			closeLoad: "modules/CLOSE_LOADING"
		}),
		...mapActions({
			doMutate: "documents/doMutate"
		}),
		scrollLoad() {
			this.loadedPages++
			this.getDocs()
		},
		handleSearch() {
			this.loadedPages = 0
			this.scrollEnded = false
			this.scrollLoading = false
			this.scrollNoMoreSnackbar = false
			this.docs = []
			this.getDocs()
		},
		changeDocVersion(doc_id, actual, index) {
			axios
				.get(process.env.VUE_APP_API_URL + "/api/flowchart/getDel/" + doc_id + "/" + actual, {
					headers: { Authorization: `Bearer ${localStorage.getItem("JWT")}` }
				})

				.then(res => {
					this.docs[index] = {
						id: res.data.items.Id,
						title: res.data.items.Title,
						status: res.data.items.Status,
						areas: res.data.items.Areas,
						tags: res.data.items.Tags,
						time: res.data.items.Preview
							? moment(res.data.items.Preview.created_at.substring(0, 19) + "+02:00").fromNow()
							: moment(moment.now()).fromNow(), // xx minutes ago
						versions: res.data.items.Versions,
						actual: actual,
						preview: res.data.items.Preview
							? [{ items: [JSON.parse(res.data.items.Preview.json)] }]
							: undefined // primo elemento del flowchart come anteprima
					}
					this.docsFilt = this.docs
					this.$forceUpdate()
				})
				.catch(err => {
					console.error(err)
					this.$notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
				})
		},

		getDocs() {
			var payload = {
				pagination: {
					offset: this.loadedPages * this.tilesNumber * this.rowsToLoad,
					size: this.rowsToLoad * this.tilesNumber
				},
				search: this.docSearch.toLowerCase()
			}

			if (!this.scrollEnded) {
				this.scrollLoading = true
				axios
					.post(process.env.VUE_APP_API_URL + "/api/flowchart/getDeleted", payload, {
						headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
					})
					.then(res => {
						this.docNumber = res.data.total
						for (let i = 0; i < res.data.items.length; i++) {
							this.docs.push({
								id: res.data.items[i].Id,
								unique_flowchart_id: res.data.items[i].UniqueFlowchartId,
								title: res.data.items[i].Title,
								status: res.data.items[i].Status,
								areas: res.data.items[i].Areas,
								tags: res.data.items[i].Tags,
								time: moment(res.data.items[i].DeletedAt.substring(0, 19) + "+02:00").fromNow(), // xx minutes ago
								versions: res.data.items[i].Versions,
								actual: res.data.items[i].Versions.find(el => el.Id == res.data.items[i].Id).Version,
								preview: res.data.items[i].Preview
									? [{ items: [JSON.parse(res.data.items[i].Preview.json)] }]
									: undefined // primo elemento del flowchart come anteprima
							})
						}
						this.scrollLoading = false
					})
					.catch(err => {
						this.scrollLoading = false
						this.scrollNoMoreSnackbar = true
						this.scrollEnded = true
					})
			} else {
				this.scrollNoMoreSnackbar = true
			}
		},

		mousein(i) {
			// nasconde la thumb e mostra le azioni
			const hide = `rnd_${i}`
			const show = `opt_${i}`
			const elHide = this.$refs[hide][0]
			const elShow = this.$refs[show][0]
			elHide.style.display = "none"
			elShow.style.cssText =
				"display:flex; flex-direction: column; justify-content: space-around; height: 100%; padding: 15px !important;"
		},
		mouseout(i) {
			// nasconde le azioni e mostra la thumb
			const hide = `opt_${i}`
			const show = `rnd_${i}`
			const elHide = this.$refs[hide][0]
			const elShow = this.$refs[show][0]
			elHide.style.display = "none"
			elShow.style.cssText = "display: flex; height: 100%"
		},
		viewInfo(id) {
			axios
				.get(process.env.VUE_APP_API_URL + "/api/flowchart/getSaved/" + id, {
					headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
				})
				.then(res => {
					this.selected_nodes = []
					res.data.items.dati.forEach((el, index) => {
						if (el.value) {
							var tttmp = { id: 0, items: [], name: "" }
							el.value.forEach(el78 => {
								tttmp.items.push(JSON.parse(el78.items))
							})
							el.value = [tttmp]
						}
						el.id = index
						this.selected_nodes.push(el)
					})
					this.showModalRender = true
				})
				.catch(err => {
					this.$notification("warning", this.$t("warning"), this.$t("generic-error-msg"))
				})
		},
		recoverModal(idx, asDraft) {
			var elementSelected = this.docs.find(x => x.id === idx)
			let hasOneVersion = elementSelected.versions.length == 1

			let allVersions = []
			elementSelected.versions.forEach(el => {
				allVersions.push(el.Id)
			})

			if (!hasOneVersion) {
				this.$confirm(this.$t("recover-multiple-version"), this.$t("warning"), {
					confirmButtonText: this.$t("all"),
					cancelButtonText: this.$t("only-selected"),
					distinguishCancelAndClose: true
				})
					.then(({ value }) => {
						//tutti
						this.recover(allVersions, asDraft, true)
					})
					.catch(action => {
						if (action === "cancel") {
							//solo quella selezionata
							this.recover([idx], asDraft, false)
						} else {
							//ho chiuso il dialog
						}
					})
			} else {
				this.recover([idx], asDraft, true)
			}
		},
		recover(ids, asDraft, allVErsions) {
			axios
				.post(
					process.env.VUE_APP_API_URL + "/api/flowchart/recoverDocs",
					{ ids: ids, asDraft: asDraft },
					{ headers: { Authorization: "Bearer " + localStorage.getItem("JWT") } }
				)
				.then(res => {
					this.$notification("success", this.$t("doc-recovered"), "", 4500)

					for (let j = 0; j < ids.length; j++) {
						let indx = this.docs.findIndex(x => x.id === ids[j])

						if (indx > -1) {
							if (allVErsions) {
								this.docs.splice(indx, 1)
								break
							} else {
								this.docs[indx].versions.splice(
									this.docs[indx].versions.findIndex(x2 => x2.Id === ids[j]),
									1
								)

								this.$nextTick(() => {
									this.docs[indx].actual = this.docs[indx].versions[0].Version
									this.changeDocVersion(this.docs[indx].versions[0].Id, this.docs[indx].actual, indx)
								})
							}
						}
					}
					// ids.map(i => this.docs.splice(this.docs.findIndex(x => x.id === i), 1))

					this.docNumber--
				})
				.catch(err => {
					this.$notification("warning", this.$t("warning"), this.$t("recover-error"))
				})
		},
		goto,
		uuid
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/collapse-button";
@import "@/assets/scss/documents.scss";

.main {
	margin-top: -25px;
}

.menu {
	font-family: "Montserrat", sans-serif;
	z-index: 2;
	position: absolute;
	left: 0;
	bottom: 0;
	top: 63px;
	width: 150px;
	background-color: #455a64;
	transition: width 0.5s;
}

.item {
	padding: 17px 10px;
	cursor: pointer;
	color: #cfd8dc;
	width: 100%;

	&:hover {
		border-left: 3px solid #6ff9ff;
	}

	display: flex;

	.md-icon {
		margin-left: 5px;
		margin-right: 5px;
	}

	span {
		margin-top: auto;
		margin-bottom: auto;
	}
}

.item-selected {
	border-left: 3px solid #6ff9ff;
	color: white;
	background-color: rgba(127, 127, 127, 0.1);
}

.selected {
	color: #6ff9ff;
}

.float-content-spinner {
	width: 50px;
	height: 50px;
	font-size: 40px;
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
	padding-top: 5px;
	transform: translate(-25px);
}

.float-content {
	width: 300px;
	height: 30px;
	transform: translate(-150px);
	background-color: rgba(214, 214, 214, 0.459);
	border-radius: 50px;
}

.visible {
	visibility: visible;
	opacity: 1;
}

.hidden {
	visibility: hidden;
	opacity: 0;
	transition: visibility 0s 1s, opacity 1s linear;
}

.float-text {
	padding-top: 5px;
}
</style>
